var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"numbers"},_vm._l((_vm.numbers),function(item,i){return _c('div',{key:i,staticClass:"numbers-item",style:(`background-color: ${_vm.colors[item]}`),on:{"click":function($event){return _vm.$emit('handleResult', item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }